import { TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'name',
    name: 'page.team.col-name',
  },
  {
    accessor: 'description',
    name: 'page.team.col-description',
  },
];
